import { ErrorWithMessage, StripeErrorMessage } from './types';

export const PRICE_CHANGED_ERROR_CODE = 'PRICE_CHANGED';

export type PriceChangedError = {
  status: 400;
  data: { code: typeof PRICE_CHANGED_ERROR_CODE; serverPrice: number; message?: string };
};

function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function isServerFailure(error: unknown): boolean {
  return isObject(error) && typeof error.status === 'number' && error.status >= 500;
}

export function isServerErrorWithMessage(error: unknown): error is ErrorWithMessage<string> {
  return isObject(error) && isObject(error.data) && typeof error.data.message === 'string';
}

export function isPriceChangedError(error: unknown): error is PriceChangedError {
  return (
    isObject(error) &&
    error.status === 400 &&
    isObject(error.data) &&
    error.data.code === PRICE_CHANGED_ERROR_CODE &&
    Number.isInteger(error.data.serverPrice)
  );
}

function getServerMessage(error: unknown): string | undefined {
  if (isServerErrorWithMessage(error)) {
    return error.data.message;
  }

  const message = isObject(error) && isObject(error.data) ? error.data.message : undefined;

  return Array.isArray(message) && typeof message[0] === 'string' ? message[0] : undefined;
}

export function getQuoteErrorMessage(error: unknown, fallback: string): string {
  if (isServerFailure(error)) {
    return fallback;
  }

  return getServerMessage(error) ?? fallback;
}

export function isStripeErrorMessage(error: unknown): error is StripeErrorMessage {
  return (
    typeof error === 'object' && 'message' in (error as StripeErrorMessage) && 'stack' in (error as StripeErrorMessage)
  );
}
